import React from 'react';
import TableHeader from "./TableHeader";
import MojeNoweSprawy from '../MojeNoweSprawy';
import BezpMail from './bezp_mail/BezpMail';
import  {Badge} from 'react-bootstrap';
import { Errors } from '../../../../partials/Partials';


function NewsBox(props) {
    const {active, problem_list, changeTable, showMore, update, loading, errors, active_id, option, setActiveId} = props
    const problem_list_content = Object.values(problem_list)[0];
    const {count, unread} = problem_list_content || '';
    let pages = ['Moje sprawy', 'Nowe sprawy', 'Bezpośredni mail do klienta z linkiem do pobrania płatności'];
    return (
        <div className="news_box col-sm-9">
            <Header 
                problems_count={count}
                active={active}
                unread_count={unread}
            />
            <div className="top-buffer-lg">
                    <Errors errors={errors}/>
            <table>
                <tbody>

                    <TableHeader 
                        pages={pages} 
                        active={active}
                        unread={unread}
                        changeTable={changeTable}
                        loading={loading}
                    />
                </tbody>
            </table>
            </div>
            <ActivePage
                problems_count={count}
                active={active}
                pages={pages}
                problem_list={problem_list}
                showMore={showMore}
                update={update}
                active_id={active_id}
                setActiveId={setActiveId}
                option={option}
            />
    </div>
    )
}

class Header extends React.Component {
    render() {
        const {problems_count, unread_count, active} = this.props
        let header = '';
        let badge = '';
        if (active === 0 || active === 1) {
            header = 'Twoje sprawy'
            badge= <Badge className="badge success"> {unread_count} / {problems_count}</Badge>
        } else if (active === 2) {
            header = "Bezpośredni mail do klienta z linkiem do pobrania płatności"
        }
        
        return(
            <h2>
                {badge}
                <span>{header}</span>
            </h2>
        )
    }
}

class ActivePage extends React.Component {
    render() {
        const {active, pages, problem_list, showMore, update, problems_count, active_id, option, setActiveId} = this.props
        if (active === 0 || active === 1) {
            return (
                <MojeNoweSprawy 
                    problems_count={problems_count}
                    active={active} 
                    pages={pages}
                    problem_list={problem_list}
                    showMore={showMore}
                    update={update}
                    active_id={active_id}
                    setActiveId={setActiveId}
                    option={option}
                />
            )
        } else {
            return (
                <BezpMail/>
            )
        }
       
    }
} 

export default NewsBox;